import type { SVGProps } from 'react';

export function SteakIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.402 13.802c-2.513 2.094-11.181 7.142-13.914 2.935L4.32 20.34A3 3 0 0 0 7 22c4 0 8.4-1.8 11.4-4.3a6.48 6.48 0 0 0 2.29-7.2l-2.253-4.532a6.5 6.5 0 0 1 .559 2.532 6.55 6.55 0 0 1-2.594 5.302" />
      <path d="M10.059 1.411a7.5 7.5 0 0 1 3.486-.333c2.89.409 4.874 2.417 5.788 4.445l2.252 4.532q.032.065.056.135a7.478 7.478 0 0 1-2.601 8.277v.002c-3.156 2.63-7.777 4.53-12.04 4.53a4.01 4.01 0 0 1-3.575-2.212l-1.812-3.565c-.599-.963-.757-2.24-.466-3.292a4 4 0 0 1 1.28-1.99l.391-.367c.84-.816 1.188-1.366 1.437-1.962.155-.37.279-.777.443-1.332.162-.544.355-1.202.639-2.01a7.5 7.5 0 0 1 4.722-4.858m9.626 9.313a7.54 7.54 0 0 1-2.644 3.845l.001.001c-1.338 1.115-4.236 2.964-7.182 4.005-1.471.52-3.037.87-4.467.77a6 6 0 0 1-.485-.053l.303.595.004.006A2 2 0 0 0 7 21c3.737 0 7.916-1.698 10.76-4.067l.043-.034a5.48 5.48 0 0 0 1.955-6.028zm-6.42-7.667a5.5 5.5 0 0 0-6.041 3.875c-.266.756-.446 1.368-.609 1.916-.16.539-.312 1.048-.514 1.534-.431 1.032-1.058 1.884-2.329 3.038l-.038.033a2 2 0 0 0-.659 1.013c-.152.548-.052 1.26.251 1.726.47.724 1.196 1.087 2.204 1.157 1.042.073 2.313-.182 3.664-.66 2.7-.954 5.393-2.676 6.568-3.655l.039-.031a5.55 5.55 0 0 0 2.195-4.487 5.5 5.5 0 0 0-.473-2.142c-.69-1.553-2.174-3.022-4.258-3.317" />
      <path d="M15 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
    </svg>
  );
}
